import { UserLine } from "src/core/models/line_model";

export type UserLineState = {
  loading: boolean | false;
  adding: boolean | false;
  updating: boolean | false;
  deleting: boolean | false;
  data: UserLine[] | [];
  code?: string;
  message?: string;
};

export const UserLineInitialState: UserLineState = {
  loading: false,
  adding: false,
  updating: false,
  deleting: false,
  data: [],
};
